module.exports = __webpack_public_path__ + "img/translation.4c281fd1.svg";